import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'

const HouseType = () => {
  const { t, houseTypeOptionsArray, housingType, updateAddress, errors, houseTypeOptions, optionalResidenceFields } =
    useAddress()

  if (!houseTypeOptionsArray) {
    return null
  }

  if (Object.entries(houseTypeOptions).length > 3) {
    return (
      <FormControl error={getError('housingType', errors)}>
        <SDSelect
          label={() => (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.housing_type'),
              }}
            />
          )}
          placeholder='Select'
          selectedValue={housingType ?? ''}
          optionsList={houseTypeOptions}
          onChangeHandler={option =>
            updateAddress({
              housingType: option.value[0]?.id ?? '',
            })
          }
        />
      </FormControl>
    )
  }

  return (
    <FormControl
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.housing_type'),
          }}
        />
      )}
      error={getError('housingType', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => updateAddress({ housingType: value })}
        options={houseTypeOptionsArray}
        selectedValue={housingType}
        newTranslations={true}
        translationsPath='subscriptionForm:address_module.house_types.'
      />
    </FormControl>
  )
}

export default HouseType
